import { useMemo } from 'react';
import { eventScreenThemeContext } from './EventScreenThemeContext';
import { useCallback } from 'react';
import { ActionType } from './actions';
import { useIframe } from '@/hooks/use-iframe';
import { useScreenThemeState } from './ScreenThemeStateContext';
import { createLogger } from '@/utils/createLogger';

const logger = createLogger('EventScreenThemeProvider');

export function EventScreenThemeProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const { dispatch, state } = useScreenThemeState();

  const handler = useCallback(
    (message: ActionType) => {
      dispatch(message);
    },
    [dispatch],
  );

  const [dispatchIframe] = useIframe(handler);

  const wrappedDispatch = useCallback(
    (message: ActionType) => {
      logger.info('dispatching message', { message });
      dispatch(message);
      dispatchIframe(message);
    },
    [dispatch, dispatchIframe],
  );

  const value = useMemo(() => {
    return {
      state,
      dispatch: wrappedDispatch,
    };
  }, [state, wrappedDispatch]);

  return (
    <eventScreenThemeContext.Provider value={value}>
      {children}
    </eventScreenThemeContext.Provider>
  );
}
